import { getInternalApiInstance } from "./base";

export interface CloneUserRequest {
  cloneEmail: string;
  sourceUserId: string;
}

export interface BackfillUserRequest {
  sourceUserId: string;
  destinationUserId: string;
}

export const cloneUserRequest = async ({
  cloneEmail,
  sourceUserId
}: CloneUserRequest, copyToStaging: boolean = false) => {
  const api = await getInternalApiInstance();
  const reqBody = {
    cloneEmail,
    sourceUserId,
    copyToStaging
  }
  try {
    await api.post("/admin/clone", { ...reqBody });
  } catch (error) {
    throw error;
  }
}

export const backfillUserRequest = async ({
  sourceUserId,
  destinationUserId
}: BackfillUserRequest) => {
  const api = await getInternalApiInstance();
  const reqBody = {
    sourceUserId,
    destinationUserId
  }
  try {
    await api.post("/admin/backfill", { ...reqBody });
  } catch (error) {
    throw error;
  }
}

export interface SafeBackfillUserRequest {
  sourceUserId: string;
  destinationUserId: string;
  confirmMismatch?: string;
}

export interface SafeBackfillResponse {
  message?: string;
  requiresConfirmation?: boolean;
  warning?: string;
  sourceName?: string;
  destinationName?: string;
}

export const safeBackfillUserRequest = async ({
  sourceUserId,
  destinationUserId,
  confirmMismatch
}: SafeBackfillUserRequest): Promise<SafeBackfillResponse> => {
  const api = await getInternalApiInstance();
  const reqBody = {
    sourceUserId,
    destinationUserId,
    confirmMismatch
  }
  try {
    const response = await api.post("/admin/safe-backfill", { ...reqBody });
    return response.data.data;
  } catch (error) {
    throw error;
  }
}


